import type {DoppeFormActionSettings} from '../../client-server-common/types/doppe-form-action-settings';
import {
    getDefaultDoppeFormActionSettings,
    prepareFormSettingsForViewer
} from '../../client-server-common/types/doppe-form-action-settings';
import type {DoppeHideableValue} from '../../client-server-common';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    DoppeAutomationTriggers,
    doppePremiumFeatureIsDisabled,
    DoppePremiumFeatures,
} from '../../client-server-common';
import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';

export namespace DoppeLockActionTypeContactForm {

    export interface ActionSettings extends DoppeFormActionSettings{
        subscribeButtonText: DoppeHideableValue<string>;
        collectEmail: boolean;
        collectPhoneNumber: boolean;
        collectName: boolean;
        collectAddress: boolean;
        collectZip: boolean;
        collectMessage: boolean;
    }
}

export const doppeLockActionTypeContactForm = doppeActionTypeDefineMetadata<DoppeLockActionTypeContactForm.ActionSettings>({
    id: 'co.hopp.lockAction/contact-form-lock',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        collectEmail: true,
        collectPhoneNumber: true,
        collectName: true,
        collectAddress: true,
        collectZip: true,
        collectMessage: false,
        subscribeButtonText: '',
        ...getDefaultDoppeFormActionSettings()
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            subscribeButtonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText),
            customConsentText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            customThankYouMessage: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            customEmailForNotifications: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            creatorsListId: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.ListOfTexts, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            linkedWixSiteListId: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.ListOfTexts, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {
                customConsentText: true,
                customEmailForNotifications: true,
                customThankYouMessage: true,
                subscribeButtonText: true
            }
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isFormAction: true,
    isLockAction: true,
    getSupportedAutomationTrigger: () => DoppeAutomationTriggers.ContactFormSubmitted,
    prepareForViewer: actionSettings => {
        prepareFormSettingsForViewer(actionSettings);
    },
    isPremiumAction: (premiumFeaturesStatus) => {
        return doppePremiumFeatureIsDisabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_form_submission)
    },
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    canRenderInPage: true,
})